import { useContext } from 'react'
import { IsInLayoutContext } from '../context/IsInLayoutContext'
import { LayoutType } from '../typings/LayoutType'

export function useIsInLayout(layout: LayoutType): boolean {
  return useContext(IsInLayoutContext) === layout
}
